import $ from 'jquery';

export const API_AUTH_KEY = "Bearer " + process.env.REACT_APP_API_AUTH_KEY;

let productStore = null;

export const setProductStore = (store) => {
    productStore = store;
};

const getApiUri = () => {
    if (productStore && productStore.selectedProduct === 'TEENS') {
        return process.env.REACT_APP_API_URI_TEENS;
    }

    return process.env.REACT_APP_API_URI_FORMATION || process.env.REACT_APP_API_URI;
};

const stripTrailingSlash = (value) => value.replace(/\/$/, '');

const webUriFromApiUri = (apiUri, fallback) => {
    if (!apiUri) {
        return fallback;
    }

    const derived = apiUri
        .replace(/-api(?=\.)/, '')
        .replace(/\/api\/v1\/?$/, '');

    return stripTrailingSlash(derived) || fallback;
};

export const getWebUri = () => {
    if (productStore && productStore.selectedProduct === 'TEENS') {
        if (process.env.REACT_APP_WEB_URI_TEENS) {
            return stripTrailingSlash(process.env.REACT_APP_WEB_URI_TEENS);
        }

        return webUriFromApiUri(
            process.env.REACT_APP_API_URI_TEENS,
            'https://teens.escolaconquer.com.br'
        );
    }

    if (process.env.REACT_APP_WEB_URI_FORMATION) {
        return stripTrailingSlash(process.env.REACT_APP_WEB_URI_FORMATION);
    }

    return 'https://formacao.escolaconquer.com.br';
};

class api {

    async call(url, method, body) {

        let params = {};
        url = getApiUri() + url;

        if (method === "GET") {

            params = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": API_AUTH_KEY
                },
                method: "GET"
            };

            if (body) {
                url = url + "?" + this._getQueryString(body)
            }

            return await fetch(url, params)
                .then(response => {
                        if (response.ok) {
                            return response.json();
                        } else {
                            return response;
                        }
                    }
                )

        } else if (method === "POST") {
            let settings;
            const currentApiUri = getApiUri();

            if (url === currentApiUri+"/students/frequencies-student-lesson"
                || url === currentApiUri+"/users/search") {
                settings = {
                    "async": true,
                    "crossDomain": true,
                    "url": url,
                    "method": "POST",
                    "headers": {
                        "Content-type": "application/json",
                        "Authorization": API_AUTH_KEY,
                        "cache-control": "no-cache",
                    },
                    "data": JSON.stringify(body)
                };

            } else {

                settings = {
                    "async": true,
                    "crossDomain": true,
                    "url": (currentApiUri + "/teachers/login"),
                    "method": "POST",
                    "headers": {
                        "content-type": "application/x-www-form-urlencoded",
                        "authorization": API_AUTH_KEY,
                        "cache-control": "no-cache",
                    },
                    "data": body
                };
            }

            return $.ajax(settings).done(function (response) {
                return Promise.resolve(response);
            });
        }
    }

    async callAttendance(url, body) {
        let settings = {
            "async": true,
            "crossDomain": true,
            "url": url,
            "method": "POST",
            "headers": {
                "Accept": "application/json"
            },
            "data": body
        };

        return $.ajax(settings).done(function (response) {
            return Promise.resolve(response);
        });
    }
    
    _getQueryString = (object) => {
        let query = [];
        Object.keys(object).forEach((k) => {
            query.push(k + "=" + object[k]);
        });
        return query.join("&");
    };


}

export default new api();


// WEBPACK FOOTER //
// ./src/utils/api.js